import { forwardRef } from 'react';
import BlockLoader from 'components/ui/ContentBlocks/BlockLoader';
import type { TreatmentPage } from 'types/contentful/generated/graphql';

type Props = {
  entry: TreatmentPage;
};

const Overview = forwardRef<HTMLElement, Props>(({ entry }, ref) => {
  return (
    <section id="overview" ref={ref}>
      <BlockLoader entry={entry.overviewCollection} />
    </section>
  );
});

Overview.displayName = 'Overview';
export default Overview;
